<template>
  <v-card class="transparent pa-4" flat>
    <v-card-title class="pb-5">
      <!--                                    v-if="$can('transaction_create')"-->
      <!--              <v-btn :to="{name:'users'}" class="btn-back">-->
      <!--                <span class="flaticon2-reply icon-lg"></span>-->
      <!--                بازگشت-->
      <!--              </v-btn>-->
      <!--              <v-spacer/>-->
      <!--              ویرایش اطلاعات کاربر-->
      <!--              <v-spacer/>-->
      <v-btn :loading="loading" class="btn-update" @click="updateUser">
        <v-icon>mdi-update</v-icon>
        بروز رسانی
      </v-btn>
      <!--                            <v-card elevation="2" outlined>-->
    </v-card-title>

    <v-row no-gutters>
      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <v-text-field
          v-model="name"
          :disabled="!can('userNameLname_edit')"
          dense
          label="نام"
          outlined
          required
        />
      </v-col>

      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <v-text-field
          v-model="lastName"
          :disabled="!can('userNameLname_edit')"
          class=""
          dense
          label="نام خانوادگی"
          outlined
          required
        />
      </v-col>

      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <v-text-field
          v-model="email"
          class=""
          dense
          label="ایمیل"
          outlined
          required
        />
      </v-col>

      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <v-text-field
          v-model="phone"
          :disabled="!can('userNumberChange_edit')"
          class=""
          dense
          label="شماره تلفن"
          outlined
          required
        />
      </v-col>

      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <v-text-field
          v-model="username"
          :disabled="!can('userUsername_edit')"
          class=""
          dense
          label="نام کاربری"
          outlined
          required
        />
      </v-col>
      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <v-text-field
          v-model="nid"
          :disabled="!can('userNumberChange_edit')"
          class=""
          dense
          label="کدملی"
          outlined
          required
        />
      </v-col>
      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <v-text-field
          v-model="password"
          :append-icon="showNewPass ? 'mdi-eye' : 'mdi-eye-off'"
          :disabled="!can('userChangepass_edit')"
          :type="showNewPass ? 'text' : 'password'"
          class=""
          counter
          dense
          label="رمز عبور"
          outlined
          @click:append="showNewPass = !showNewPass"
        />
      </v-col>
      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <pack-picker
          v-model="role"
          :disabled="!can('userChangeRole_edit')"
          :packTitle="roleTitle"
          @packSelected="
            (val) => {
              this.role = val;
            }
          "
          @packSelectedTitle="
            (val) => {
              this.roleTitle = val;
            }
          "
        />
      </v-col>

      <users-picker
      ref="userPicker"
        v-model="parent_id"
        :old-data="parent"
        title="انتخاب معرف"
        class="pa-2"
      />

      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <sms-tariff-picker v-model="price_id" />
      </v-col>

      <v-col cols="12" lg="3" md="4" sm="6" class="mr-5">
        <v-switch
          :disabled="loading"
          @change="postAcc"
          hide-details
          :loading="loading"
          class="mt-2"
          :label="
            payamak_accept
              ? 'تایید اتوماتیک پیامک (فعال)'
              : 'تایید اتوماتیک پیامک (غیرفعال)'
          "
          v-model="payamak_accept"
        >
        </v-switch>
      </v-col>

      <!--      <v-col cols="12" md="6" class="pa-2">-->
      <!--        <v-autocomplete-->
      <!--            append-icon="mdi-account-supervisor"-->
      <!--            :items="users.data"-->
      <!--            item-text="name"-->
      <!--            v-model="parent_id"-->
      <!--            :loading="loading"-->
      <!--            item-value="id"-->
      <!--            @change="getUsers($event)"-->
      <!--            clearable-->
      <!--            outlined dense-->
      <!--            label="تغییر معرف"-->
      <!--        >-->
      <!--          <template slot="item" slot-scope="{ item, tile }">-->
      <!--            <div>{{ item.name + " " + item.lastName }}</div>-->
      <!--          </template>-->

      <!--          <template slot="append-item">-->
      <!--            <div class="text-center">-->
      <!--              <v-pagination-->
      <!--                  v-model="page"-->
      <!--                  :length="users.last_page"-->
      <!--                  :total-visible="3"-->
      <!--                  circle/>-->
      <!--            </div>-->
      <!--          </template>-->
      <!--        </v-autocomplete>-->
      <!--      </v-col>-->

      <v-col v-if="can('parent_edit')" cols="12" md="6">
        <!--                  <v-autocomplete label="معرف"-->
        <!--                                  dense append-icon="mdi-account-supervisor" editable-->
        <!--                                  auto-select-first outlined-->
        <!--                                  v-model="parent_id" :items="users"/>-->

        <v-card-text
          >معرف فعلی:{{
            parent !== null
              ? " " + parent.name + " " + parent.lastName
              : "ندارد"
          }}
        </v-card-text>
      </v-col>

      <v-col class="pa-2" cols="12" md="6">
        <label for="user">وضعیت کاربر</label>
        <v-radio-group v-model="status" class="ma-0">
          <v-radio label="فعال" value="active" />
          <v-radio label="غیر فعال" value="deactive" />
        </v-radio-group>
      </v-col>

      <v-col class="pa-2" cols="12" md="6">
        <label for="send">وضعیت ارسال پیامک کمپین</label>
        <v-radio-group v-model="send_sms" class="ma-0">
          <v-radio label="فعال" value="1" />
          <v-radio label="غیر فعال" value="0" />
        </v-radio-group>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import PackPicker from "@/view/pages/pickers/packPicker";
import userPicker from "../../../pickers/userPicker";
import UsersPicker from "@/view/pages/pickers/usersPicker.vue";
import SmsTariffPicker from "../../../pickers/smsTariffPicker.vue";

export default {
  name: "Edit",
  components: { UsersPicker, PackPicker, userPicker, SmsTariffPicker },
  props: ["id"],
  data() {
    return {
      pickedUser: null,
      query: {
        page: 1,
        search: "",
        length: 20,
      },
      status: null,
      page: 1,
      search: "",
      parent_id: null,
      users: [],
      parentTitle: "",
      loading: false,
      name: null,
      parent: null,
      nid: null,
      lastName: null,
      showNewPass: false,
      email: null,
      phone: null,
      role: null,
      roleTitle: null,
      roles: null,
      username: null,
      password: "",
      send_sms: null,
      payamak_accept: false,
      price_id: null,
    };
  },
  created() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t(this.$route.meta.title) },
    ]);
    this.findUser();
    this.getUsers();
  },

  mounted() {
    this.fetchAcc();
  },
  methods: {
    findUser() {
      this.requestApiGet("user/" + this.id).then(({ data }) => {
        this.name = data.name;
        this.nid = data.nid;
        this.lastName = data.lastName;
        this.email = data.email;
        this.parent_id = data.parent_id;
        this.phone = data.phone;
        this.username = data.username;
        this.price_id = data.price_id;
        this.status = data.status;
        this.send_sms = data.send_sms.toString();
        this.role = data.packs[0].id;
        this.roleTitle = data.packs[0].title;
        this.parent = data.parent;
        this.parentTitle =
          data.parent !== null
            ? data.parent.name + "  " + data.parent.lastName
            : "معرف ندارد";
      });
    },

    updateUser() {
      this.loading = true;
      this.requestApiPost(`user/${this.id}`, {
        name: this.name,
        user_id: this.id,
        lastName: this.lastName,
        email: this.email,
        phone: this.phone,
        parent_id: this.parent_id,
        username: this.username,
        price_id: this.price_id,
        password: this.password,
        status: this.status,
        send_sms: this.send_sms,
        nid: this.nid,
        role: this.role,
        _method: "PUT",
      }).then(({ data }) => {
        this.loading = false;
        this.$toast.success("کاربر با موفقیت ویرایش شد.");
        this.$router.push({ name: "users" });
      });
    },
    getMessageQuery() {
      console.log(this.search);
      if (this.category_id !== null) return this.getMessage(this.parent_id);
      if (this.search !== null) return (this.messages = []);
    },

    async fetchAcc() {
      try {
        this.loading = true;
        await this.requestApiGetPayamak(`admin/users/metas`, { user_id: this.id }
          )
          .then(({ data }) => {
            if (data?.data?.length == 0) {
              this.payamak_accept = false;
              return;
            }

            console.log(data.data);

            this.payamak_accept =
              data.data?.find((item) => item.key == "payamak_accept").value ==
              "1"
                ? true
                : false;
          });
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },

    async postAcc() {
      let before = this.payamak_accept;
      try {
        this.loading = true;
        await this.requestApiPostPayamak(`admin/users/add/permission`, {
            key: "payamak_accept",
            value: this.payamak_accept,
            user_id: this.id,
          })
          .then(({ data }) => {
            this.fetchAcc();
            this.$toast.success("تغییر با موفقیت انجام شد");
          });
      } catch (err) {
        this.$toast.error("مشکلی پیش آمده است");
        this.payamak_accept = !before;
        console.log(err);
      } finally {
        this.loading = false;
      }
    },

    getUsers() {
      this.loading = true;
      this.requestApiGet("admin/users", this.query)
        .then(({ data }) => {
          this.users = data;
          this.loading = false;
        })
        .catch(({ response }) =>
          console.log("error in get provinces: ", response)
        );
    },
  },
  watch: {
    page(val) {
      this.query.page = val;
      this.getUsers();
    },
    search(val) {
      this.query.search = val;
      this.getUsers();
    },
    payamak_accept(val) {
      console.log(val);
    },
  },
};
</script>

<style scoped></style>
